<template>
  <div class="container py-4">
    <h4 class="mb-3 cardD">Asignar Correduría</h4>

    <b-row>
      <b-col md="6">
        <h6 class="text-muted mb-3">Ubicación del cliente (datos de contacto)</h6>

        <div class="mb-3">
          <label class="font-weight-bold d-block">Entidad federativa</label>
          <span>{{ clienteEntidad }}</span>
        </div>

        <div class="mb-4">
          <label class="font-weight-bold d-block">Municipio</label>
          <span>{{ clienteMunicipio }}</span>
        </div>
      </b-col>

      <b-col md="6">
        <h6 class="text-muted mb-3">Ubicación de entrega de documentos (seleccionada por el cliente)</h6>

        <div class="mb-3" v-if="cotejo.domicilio_entrega_originales">
          <label class="font-weight-bold d-block">Entidad federativa</label>
          <span>{{ cotejo.domicilio_entrega_originales.entidad }}</span>
        </div>
        <div class="mb-3" v-else>
          <span class="text-muted">No seleccionada</span>
        </div>
      </b-col>
    </b-row>

    <h6 class="text-muted mb-3 mt-3">Correduría</h6>

    <b-form-group label="Seleccionar Correduría" label-for="correduria-select" class="mb-4">
      <b-form-select id="correduria-select" v-model="selectedCorreduria" :options="options_correduria" class="w-50" />
    </b-form-group>

    <!-- Action button -->
    <div class="text-right">
      <b-button @click="selectCorreduria" class="btn-fill orange-btn px-4">Asignar</b-button>
    </div>
  </div>
</template>

<script>
import { FuncionesApi, DomiciliosApi } from "@/api";
import loadingMixin from "@/mixins/loadingMixin";

export default {
  name: "TabAsignarCorreduria",

  props: {
    cotejo: { type: Object },
  },

  mixins: [loadingMixin],

  async created() {
    const clienteDomicilios = this.cotejo.solicitante.domicilios;

    if (clienteDomicilios.length > 0) {
      this.clienteEntidad = clienteDomicilios[0].entidad;
      this.clienteMunicipio = clienteDomicilios[0].delegacion_municipio;
    }

    if (!this.cotejo.domicilio_entrega_originales && this.cotejo.id_domicilio_entrega_originales) {
      try {
        const response = await DomiciliosApi.detail(this.cotejo.id_domicilio_entrega_originales);
        this.$set(this.cotejo, "domicilio_entrega_originales", response.data || response);
      } catch (error) {
        console.error("Error fetching domicilio_entrega_originales:", error);
      }
    }

    this.selectedCorreduria = this.cotejo.corredurias_id;
    this.getCorredurias();
  },

  data() {
    return {
      clienteEntidad: "",
      clienteMunicipio: "",
      entidad: null,
      municipio: null,
      options_correduria: [],
      selectedCorreduria: 1,
    };
  },

  methods: {
    async getCorredurias() {
      try {
        this.toggleOnLoading();

        this.entidad = this.cotejo.domicilio.entidad;
        if (this.entidad != "Ciudad de México") {
          this.municipio = this.cotejo.domicilio.delegacion_municipio;
        }

        let value;

        const response = await FuncionesApi.getCorreduriasDomicilios({
          entidad: this.clienteEntidad,
          municipio: this.clienteMunicipio,
        });

        value = response.value;

        if (!value || value.length === 0) {
          const fallback = await FuncionesApi.getCorreduriasDomicilios({
            entidad: null,
            municipio: null,
          });
          value = fallback.value;
        }

        this.options_correduria = value
          .filter((d) => d.corredurias_id != 17)
          .map((d) => ({
            text: `${d.entidad}, ${d.delegacion_municipio}, ${d.colonia}`,
            value: d.corredurias_id,
          }));
      } catch (error) {
        console.log(error);
      } finally {
        this.toggleOffLoading();
      }
    },

    selectCorreduria() {
      this.cotejo.corredurias_id = this.selectedCorreduria;
      this.$emit("allChecksPassed");
    },
  },
};
</script>
